import { render } from "./DocumentComparisonSpreadsheet.vue?vue&type=template&id=424d83a6&scoped=true&ts=true"
import script from "./DocumentComparisonSpreadsheet.vue?vue&type=script&lang=ts"
export * from "./DocumentComparisonSpreadsheet.vue?vue&type=script&lang=ts"

import "./DocumentComparisonSpreadsheet.vue?vue&type=style&index=0&id=424d83a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424d83a6"]])

export default __exports__